export default __webpack_public_path__ + "img/64a9c1f5898eb7ae4e11afd42cda3252.svg";